import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollReportExport  {
    _originalTypeClassName = "zERP.BO.PayrollReportExport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollReportExport.translate = translateService;
}
this.PayrollReportExportKey = null;
this._key = this.PayrollReportExportKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollReportExportKey:any;
get PayrollReportExportKey(): any {
    return this._PayrollReportExportKey;
  }
set PayrollReportExportKey(value: any) {
    this._PayrollReportExportKey = value;
    this._key = value;
  }

static GetCollectionVariables(pay: any): any{console.warn("get collection payroll 5");
let vars = new window['Map']();
let employeeVars = [];
console.warn("get collection payroll 9");
employeeVars?.add({
Name: "AM",Description: "ΑΜ",}
);
employeeVars?.add({
Name: "Lastname",Description: "Επώνυμο",}
);
employeeVars?.add({
Name: "Name",Description: "Όνομα",}
);
employeeVars?.add({
Name: "AMA",Description: "ΑΜΑ",}
);
employeeVars?.add({
Name: "GrossAmount",Description: "Μεικτές Αποδοχές",}
);
employeeVars?.add({
Name: "DaysInsured",Description: "Ημέρες Ασφάλισης",}
);
employeeVars?.add({
Name: "EmployeeDeductions",Description: "Εισφορά Εργαζόμενου",}
);
employeeVars?.add({
Name: "EmployerDeductions",Description: "Εισφορά Εργοδότη",}
);
employeeVars?.add({
Name: "TotalDeductions",Description: "Σύνολο Εισφορών",}
);
employeeVars?.add({
Name: "InsuredIncome",Description: "Ασφαλιστέες Αποδοχές",}
);
employeeVars?.add({
Name: "RegistryName",Description: "Ταμείο",}
);
console.warn("get collection payroll 21");
vars.set({
Name: "SocialRegistries",Description: "Ταμεία",IsCollection: true,Children: employeeVars,}
, Joove.Common.cast(pay?.Employees, "System.Collections.List"));
console.warn("get collection payroll 30");
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{console.warn("resolve payroll 3");
if (collectionName == "SocialRegistries") {let Rule = Joove.Common.cast(item, "Domain.SalaryDeductionRule");let Emp = Joove.Common.cast(item, "Domain.Employee");let pay = Joove.Common.cast(item, "Domain.EmployeePayroll");let totalcontribution = 0;totalcontribution = Joove.Common.safeNumber(pay?.EmployeeContributions) + Joove.Common.safeNumber(pay?.EmployerContributions);console.warn("resolve payroll 12" + pay?.Contributions?.linq?.where()?.firstOrDefault(null)?.Rule?.Name);switch (varName?.toLowerCase()) {case "am":
{
return pay?.Employee?.Code;}
case "lastname":
{
return pay?.Employee?.LastName;}
case "name":
{
return pay?.Employee?.FirstName;}
case "ama":
{
return pay?.Employee?.SocialRegistryNumber;}
case "grossamount":
{
return pay?.TotalSalary;}
case "daysinsured":
{
return pay?.DaysInsured;}
case "employeedeductions":
{
return pay?.EmployeeContributions;}
case "employerdeductions":
{
return pay?.EmployerContributions;}
case "totaldeductions":
{
return totalcontribution;}
case "insuredincome":
{
return pay?.PayableAmount;}
case "registryname":
{
return pay?.Contributions?.linq?.where()?.firstOrDefault(null)?.Rule?.Name;}
}}
return "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollReportExportKey == null || $this.PayrollReportExportKey == 0;
            }


}